import React from "react";
import styled from "styled-components";
import { Typography } from "../Typography/Typography";

interface Props {
  text?: string;
  variant?:
    | "display"
    | "titleLarge"
    | "titleMedium"
    | "titleSmall"
    | "subTitle"
    | "bodyLarge"
    | "bodyMedium"
    | "bodySmall"
    | "fieldTitle";
  children: React.ReactNode;
}

export const Label: React.FC<Props> = (props) => {
  const { text, children } = props;
  if (!text) {
    return <div>{children}</div>;
  }

  return (
    <Wrapper>
      <Typography variant={props.variant || "bodyMedium"}>{text}</Typography>
      <div>{children}</div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
